var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlug(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "plug"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_7268_165922",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 25
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    y: 0.5,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_7268_165922)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "vector",
    d: "M11.4 19.1H12.6V17.75L16.2 14.15V9.49998H7.8V14.15L11.4 17.75V19.1ZM9.6 20.9V18.5L6 14.9V9.49998C6 9.00498 6.17625 8.58123 6.52875 8.22873C6.88125 7.87623 7.305 7.69998 7.8 7.69998H9.15L8.4 8.79998V4.09998H10.2V7.69998H13.8V4.09998H15.6V8.79998L14.85 7.69998H16.2C16.695 7.69998 17.1188 7.87623 17.4713 8.22873C17.8238 8.58123 18 9.00498 18 9.49998V14.9L14.4 18.5V20.9H9.6Z",
    fill: "#1F6CF9"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlug);
export default __webpack_public_path__ + "static/media/plug.b5f3edb37096360a1e355779f3eb1ed9.svg";
export { ForwardRef as ReactComponent };